<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-xl-2 col-lg-3 col-md-3 col-sm-12 col-12 bg-silver mt-3">
                <app-search-filter :query="category"></app-search-filter>
            </div>
            <div class="col-xl-10 col-lg-9 col-md-9 col-sm-12 col-12">
                <div class="row">
                    <app-item v-for="(item, index) in theItemsOnDisplay" :key="index" :item="item"></app-item>
                </div>
            </div>
        </div>
        
        <!-- infinite scroller -->
        <app-infinite-scroller @emitLoadMoreContent="loadMoreContentFxn"></app-infinite-scroller>
        <div v-if="showLoader" class="text-center text-dark-green mt-4">
            <i class="fas fa-spinner fa-pulse fa-2x"></i>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { webpageTitle, capitalizeWord } from '@/store/dry'

import Item from '../shared/Item.vue'
import SearchFilter from './searchParts/SearchFilter.vue'
import InfiniteScroller from '@/components/general/shared/InfiniteScroller.vue'
import LayoutGeneral from '@/layouts/General.vue'

export default {
    name: 'CategoryItems',
    props: {
        category: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            skipNumber: 0,
            limitNumber: 24,
            showLoader: false
        }
    },
    methods: {
        ...mapActions(['categoryItemsAction', 'emptyItemsOnDisplayAction']),
        categoryItemsFxn(theCategory) {
            let categoryObj = {
                category: theCategory,
                skipNumber: this.skipNumber,
                limitNumber: this.limitNumber,
            }
            this.categoryItemsAction(categoryObj).then(() => {}).catch((e) => {})
        },
        loadMoreContentFxn(){
            if(!this.theItemsOnDisplay) return

            // get total length of displayed items to increase the skip number value
            this.skipNumber = this.theItemsOnDisplay.length
            this.showLoader = true
            
            // simulate ajax delay before fetching new contents
            setTimeout(() => {
                this.categoryItemsFxn(this.category)
                this.showLoader = false
            }, 3000);
        }
    },
    computed: {
        ...mapGetters(['itemsOnDisplay']),
        theItemsOnDisplay() {
            if(this.itemsOnDisplay){
                return this.itemsOnDisplay
            }
            return false
        },
    },
    components: {
        appItem: Item,
        appSearchFilter: SearchFilter,
        appInfiniteScroller: InfiniteScroller
    },
    watch: {
        category() {
            this.categoryItemsFxn(this.category)
        }
    },
    mounted() {
        this.emptyItemsOnDisplayAction()
    },
    created() {
        this.categoryItemsFxn(this.category)
        webpageTitle(capitalizeWord(this.category))
        this.$emit('update:layout', LayoutGeneral);
    }
}
</script>